import React, { useContext } from 'react';
import { bool, func, shape } from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Drawer, DrawerItem } from '@thd-olt-component-react/drawer';
import { QuickViewDetails } from '../quick-view-details/QuickViewDetails';
import { QuickViewOverview } from '../quick-view-overview/QuickViewOverview';
import { QuickViewSpecs } from '../quick-view-specifications/QuickViewSpecs';
import { QuickViewReviews } from '../quick-view-reviews/QuickViewReviews';
import { QuickViewProvider } from '../../utils/QuickViewProvider';
import { QuickViewSuspense } from '../quick-view-suspense/QuickViewSuspense';

export const QuickViewDrawer = ({
  isOpen,
  onClose,
  product
}) => {

  const { channel } = useContext(ExperienceContext);
  const isMobile = channel !== 'desktop';

  return (
    <div className="quick-view">
      <QuickViewProvider value={{ product }}>
        <Drawer
          open={isOpen}
          onClose={onClose}
          initialItem="quick-view-info"
          maxSize={isMobile ? 100 : 510}
          isMobile={isMobile}
          zIndex={9998}
        >
          <DrawerItem name="quick-view-info">
            <QuickViewSuspense>
              <QuickViewDetails />
            </QuickViewSuspense>
          </DrawerItem>

          <DrawerItem name="quick-view-product-overview">
            <QuickViewSuspense>
              <QuickViewOverview />
            </QuickViewSuspense>
          </DrawerItem>

          <DrawerItem name="quick-view-product-specs">
            <QuickViewSuspense>
              <QuickViewSpecs />
            </QuickViewSuspense>
          </DrawerItem>

          <DrawerItem name="quick-view-product-reviews">
            <QuickViewSuspense>
              <QuickViewReviews />
            </QuickViewSuspense>
          </DrawerItem>
        </Drawer>
      </QuickViewProvider>
    </div>
  );
};

QuickViewDrawer.displayName = 'QuickViewDrawer';

QuickViewDrawer.propTypes = {
  isOpen: bool.isRequired,
  onClose: func,
  product: shape()
};

QuickViewDrawer.defaultProps = {
  onClose: () => {},
  product: null
};